import { getDayOfWeekName } from "../../../extensions/helper";

const CalendarDow = ({ dow, left, top, width, height }) => {
  const style={left, top, width, height}

  return<div style={style} className="calendar-dow">
    {getDayOfWeekName(dow)}
  </div>
}

export default CalendarDow;